module.exports = __webpack_public_path__ + "static/media/mimi4.6b657423.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mimi4.gif
// module id = 296
// module chunks = 0